import React from 'react';

import { ButtonProps } from '@/components/shadcn/ui/button';
import { ConnectedLtcWallet } from '@/networks/btc-like/ltc';

const HeaderWalletDrawerLtcWalletConnect: React.FC<ButtonProps> = (props) => {
  return <ConnectedLtcWallet {...props} />;
};

export default HeaderWalletDrawerLtcWalletConnect;
